"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _Uploader = require("../../../../../Uploader");

require("./_comment-title.scss");

function CommentTitle(_ref) {
  var color = _ref.color,
      brightness = _ref.brightness,
      commentIndex = _ref.commentIndex,
      asset = _ref.asset,
      title = (asset || {}).title;
  return _react["default"].createElement("div", {
    className: "comment-title"
  }, _react["default"].createElement("div", {
    className: "comment-title__number",
    style: {
      backgroundColor: color,
      filter: brightness
    }
  }, commentIndex + 1), _react["default"].createElement("div", {
    className: "comment-title__title"
  }, title || "UNKNOWN"));
}

var _default = (0, _Uploader.withAssetSelector)(CommentTitle);

exports["default"] = _default;